import styled from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../../components/SalesReport/tokens'

const MOBILE = '@media (max-width: 767px)'

export const Content = styled.section`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;

  ${MOBILE} {
    gap: 16px;
  }
`

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;

  ${MOBILE} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
`

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  ${MOBILE} {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
`

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  box-sizing: border-box;
  padding: 20px 24px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};

  ${MOBILE} {
    padding: 16px;
  }
`

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${colors.ink950};
`

export const CardSubtitle = styled.p`
  margin: -8px 0 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: ${colors.ink500};
`

export const BarList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const BarRow = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const BarHead = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.ink800};
`

export const BarValue = styled.span`
  flex-shrink: 0;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${colors.ink950};
`

export const Footnote = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.ink500};
`

export const Empty = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${colors.ink500};
`

export const Period = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
`

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    ${fieldLabel}
  }

  input {
    height: 40px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid ${colors.border};
    border-radius: ${radius.input};
    background: ${colors.white};
    font-size: 14px;
    color: ${colors.ink900};
  }
`

export const FieldError = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${colors.dangerText};
`
